import { render, staticRenderFns } from "./TacticalUnitStandards.vue?vue&type=template&id=7482e03e&"
import script from "./TacticalUnitStandards.vue?vue&type=script&lang=ts&"
export * from "./TacticalUnitStandards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports